module.exports = __webpack_public_path__ + "static/media/reactCA.9d47066d.svg";